import {Card, CardContent} from "@/components/ui/card.tsx";
import React from "react";

export interface ActionCardProps {
    className?: string;
    title: string;
    description: string;
    link: string;
    color: 'yellow' | 'green' | 'rose' | 'blue' | 'orange' | 'gray' | 'green-dark';
    icon: React.FC<React.SVGProps<SVGSVGElement>>;
}

export function ActionCard(props: ActionCardProps) {

    const {
        className,
        title = "כותרת",
        description = "10,815",
        link,
        color,
    } = props;

    const colorClasses = {
        yellow: "border-yellow-200 bg-yellow-100 text-yellow-500",
        green: "border-green-200 bg-green-100 text-green-500",
        'green-dark': "border-green-200 bg-green-100 text-green-600",
        rose: "border-rose-200 bg-rose-100 text-rose-600",
        blue: "border-blue-200 bg-blue-50 text-light-blue-600",
        orange: "border-orange-200 bg-orange-100 text-orange-400",
        gray: "border-gray-200 bg-gray-100 text-gray-500",
    }[color] ?? "border-gray-200 bg-gray-100 text-gray-500";

    return (
        <a href={link || '#'} target={link.startsWith('http') ? '_blank' : undefined} className="h-full">
            <Card className="cursor-pointer hover:shadow-2xl hover:-translate-y-0.5 transition-all h-full">
                <CardContent className="!px-6 !py-9">
                    <div className="flex gap-2.5 pb-4">
                        <div>
                        <span className={"flex justify-center items-center h-12 w-12 rounded-full border " + colorClasses}>
                            <props.icon className="w-6 h-6 stroke-2"/>
                        </span>
                        </div>
                        <div>
                            <div className="font-bold text-gray-700">{title}</div>
                            <div className="text-sm text-gray-500">
                                {description}
                            </div>
                        </div>
                    </div>
                </CardContent>
            </Card>
        </a>
    )
}